import Http from './index.js'

export default class Model {
  constructor(path = '') {
    this.model = path
  }

  list(query = '') {
    return Http.get(`${this.model}${query}`)
  }

  read(id, query = '') {
    return Http.get(`${this.model}${id}/${query}`)
  }

  historic(id, query = '') {
    return Http.get(`${this.model}${id}/historic/${query}`)
  }

  create(payload) {
    return Http.post(this.model, payload)
  }

  update(id, obj) {
    return Http.put(`${this.model}${id}/`, obj)
  }

  partialUpdate(id, obj) {
    return Http.patch(`${this.model}${id}/`, obj)
  }

  delete(id) {
    return Http.delete(this.model + id)
  }
}
